export default "__VITE_ASSET__DbGxTsvM__"